import { client } from './client';
import type { ApiResponse } from '@/types/api';
import type { NoteResponse, CreateNoteInput } from '@/types/note';

export async function createNote(input: CreateNoteInput): Promise<NoteResponse> {
  const { data } = await client.post<ApiResponse<NoteResponse>>('/api/v1/teachers/notes', input);
  return data.data;
}

export async function listNotes(studentId: string): Promise<NoteResponse[]> {
  const { data } = await client.get<ApiResponse<NoteResponse[]>>('/api/v1/teachers/notes', {
    params: { student_id: studentId },
  });
  return data.data;
}

export async function deleteNote(id: string): Promise<void> {
  await client.delete(`/api/v1/teachers/notes/${id}`);
}
